import React from 'react';
import { AvTooltip } from '@fabric-ui/components';
import { DrillDown } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { Box } from '@mui/material';
import { defaultDrillDownHierarchy } from '../constants';
import { useGetDisplayName } from '../hooks/useGetDisplayName';
import { AllTypeWidgets } from '../types/combined.types';

const drillDownIcon = <DrillDown />;

interface DrillUpButtonProps {
  widget: AllTypeWidgets;
}

const DrillUpButton: React.FC<DrillUpButtonProps> = ({ widget }) => {
  const getDisplayName = useGetDisplayName(widget.requests[0].projectionId.name);

  const {
    requests: [
      {
        select: { dims },
      },
    ],
    drillDownHierarchy = defaultDrillDownHierarchy,
  } = widget;

  return (
    <AvTooltip
      title={
        drillDownHierarchy.activeIndex === 0
          ? 'Click on chart to drill down'
          : `Drill up to ${getDisplayName([dims[0], ...drillDownHierarchy.fields][drillDownHierarchy.activeIndex - 1]?.name)}`
      }>
      <Box sx={flex.center} className="draggableCancel">
        {drillDownHierarchy.activeIndex === 0 ? drillDownIcon : undefined}
      </Box>
    </AvTooltip>
  );
};

export default DrillUpButton;
